module.exports = __webpack_public_path__ + "fonts/iconfont.5ddd3e14.woff2";